import React from 'react';
import { motion } from 'framer-motion';
import { getTier } from '../data/resultTiers';
interface ResultSectionProps {
  score: number;
}
export const ResultSection: React.FC<ResultSectionProps> = ({
  score
}) => {
  const tier = getTier(score);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white px-6 py-16 md:py-24 flex flex-col items-center" data-id="element-125">
      <div className="max-w-2xl w-full mx-auto" data-id="element-126">
        {/* Header Badge */}
        <div className="flex justify-center mb-8" data-id="element-127">
          <span className={`${tier.badgeColor} text-white text-sm font-bold px-5 py-2 rounded-full shadow-sm`} data-id="element-128">
            {tier.badgeText}
          </span>
        </div>

        {/* Title & Description */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-dark-blue text-center mb-6 leading-tight" data-id="element-129">
          {tier.title}
        </h2>

        <p className="text-lg text-gray-700 text-center mb-10 leading-relaxed" data-id="element-130">
          {tier.description}
        </p>

        {/* Level Bar */}
        <div className="mb-8" data-id="element-131">
          <div className="w-full h-4 bg-gray-100 rounded-full overflow-hidden mb-3" data-id="element-132">
            <motion.div className={`h-full ${tier.barColor}`} initial={{
            width: 0
          }} animate={{
            width: `${tier.percentage}%`
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: 'easeOut'
          }} data-id="element-133" />
          </div>
          <p className="text-center font-bold text-gray-500" data-id="element-134">
            Tu puntuación: {score} de 40
          </p>
        </div>

        <hr className="border-gray-200 my-10" data-id="element-135" />

        {/* Consequences */}
        <h3 className="text-2xl font-bold text-dark-blue text-center mb-8" data-id="element-136">
          Lo que tu resultado significa para ti:
        </h3>

        <div className="flex justify-center gap-8" data-id="element-137">
          {tier.icons.map((icon, idx) => <div key={idx} className="w-16 h-16 bg-lavender rounded-2xl flex items-center justify-center text-3xl shadow-sm" data-id="element-138">
              {icon}
            </div>)}
        </div>
      </div>
    </motion.div>;
};